import type { Message } from '../types';
import MetricsDisplay from './MetricsDisplay';

interface MessageBubbleProps {
  message: Message;
  modelDisplayName?: string;
}

export default function MessageBubble({
  message,
  modelDisplayName,
}: MessageBubbleProps) {
  const roleClass =
    message.role === 'user' ? 'message-user' : 'message-assistant';

  return (
    <div className={`message-bubble ${roleClass}`}>
      <span className="message-role">
        {message.role === 'user' ? 'You' : 'AI'}
      </span>
      <p className="message-content">{message.content}</p>
      {message.role === 'assistant' && message.metrics && (
        <MetricsDisplay
          metrics={message.metrics}
          modelDisplayName={modelDisplayName ?? ''}
        />
      )}
    </div>
  );
}
